import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DollarSign } from 'lucide-react';
import TransactionStatementList from './TransactionStatementList';
import TaxInvoiceList from './TaxInvoiceList';
import PageHeader from './common/PageHeader';

const tabs = [
    { key: 'order', label: '주문 거래명세서' },
    // { key: 'outsource', label: '외주 거래명세서' },   // 10-30 대표: 옛 외주 데이터·화면 삭제
    // { key: 'tax', label: '전자세금계산서' }, // 추후 활성화
];

function StatementsHub({ user }) {
    const [activeTab, setActiveTab] = useState('order');
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <PageHeader icon={DollarSign} title="거래명세서" />
            <div style={styles.tabBar}>
                {tabs.map(t => (
                    <button
                        key={t.key}
                        onClick={() => setActiveTab(t.key)}
                        style={{
                            ...styles.tab,
                            backgroundColor: activeTab === t.key ? '#6366f1' : '#f1f5f9',
                            color: activeTab === t.key ? '#fff' : '#64748b',
                        }}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            {activeTab === 'order' ? (
                <TransactionStatementList user={user} />
            ) : (
                <TaxInvoiceList
                    user={user}
                    onSelectInvoice={(id) => navigate(`/tax-invoices/${id}`)}
                    onCreateNew={() => navigate('/tax-invoices/create')}
                />
            )}
        </div>
    );
}

const styles = {
    container: { padding: '24px', maxWidth: 1200, margin: '0 auto' },
    tabBar: { display: 'flex', gap: 8, marginBottom: 20 },
    tab: {
        padding: '8px 16px', border: 'none', borderRadius: 8,
        fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s',
    },
};

export default StatementsHub;
